export enum FeatureFlagKeys {
  Preview = 'preview',
  MonitorTrigger = 'monitor-trigger',
  PushNotification = 'push-notification',
  PushNotificationService = 'push-notification-service',
  DeliveryRate = 'delivery-rate',
  NotificationEngagmentDetails = 'notification-engagment-details',
  SingleNotificationAnalyticsSinceCreation = 'single-notification-analytics-since-creation',
  W5GFullFlexLayout = 'w5g-full-flex-layout',
  HashEndUsersIds = 'hash-end-users-ids',
  LegacyAnalyticsDisabled = 'legacy-analytics-disabled',
  Internationalization = 'internationalization',
  Permissions = 'permissions',
  W5G_UI_V3 = 'w5g-ui-v3',
}

export enum AnalyticsSource {
  Legacy = 'Legacy',
  Workstation = 'Workstation',
}

export enum LanguageCode {
  EN = 'en',
  JA = 'ja',
}

export enum WalkmeFeatureFlags {
  CCRemovePotentialRecipients = 'ccRemovePotentialRecipients',
  AssetsIncreaseMaxSizes = 'assetsIncreaseMaxSizes',
  AssetsIncreaseMaxSizesDouble = 'assetsIncreaseMaxSizesDouble',
}
